import clsx from 'clsx'
import {KTSVG} from '../../../helpers'
import {LayoutWidthType, ThemeModeType, useThemeMode} from './ThemeModeProvider'

/* eslint-disable jsx-a11y/anchor-is-valid */
type Props = {
  toggleBtnClass?: string
  toggleBtnIconClass?: string
  menuPlacement?: string
  menuTrigger?: string
}

const ThemeModeSwitcher = ({
  toggleBtnClass = '',
  toggleBtnIconClass = 'svg-icon-2',
  menuPlacement = 'bottom-end',
  menuTrigger = 'click',
}: Props) => {
  const {mode, menuMode, layoutWidth, updateMode, updateMenuMode, updateLayoutWidth} =
    useThemeMode()
  const switchMode = (_mode: ThemeModeType) => {
    updateMenuMode(_mode)
    updateMode(_mode)
  }

  const switchLayoutWidth = (_layoutWidth: LayoutWidthType) => {
    updateLayoutWidth(_layoutWidth)
  }

  return (
    <>
      {/* begin::Menu toggle */}
      <button
        type='button'
        className={clsx('btn btn-icon nosi-topbar-button', toggleBtnClass)}
        data-kt-menu-trigger={menuTrigger}
        data-kt-menu-attach='parent'
        data-kt-menu-placement={menuPlacement}
        aria-label='Görünüm ve tema ayarları'
        title='Görünüm'
      >
        {mode === 'dark' && (
          <KTSVG
            path='/media/icons/duotune/general/gen061.svg'
            className={clsx('theme-light-hide', toggleBtnIconClass)}
          />
        )}

        {mode === 'light' && (
          <KTSVG
            path='/media/icons/duotune/general/gen060.svg'
            className={clsx('theme-dark-hide', toggleBtnIconClass)}
          />
        )}
      </button>
      {/* begin::Menu toggle */}

      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base nosi-theme-menu'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3 my-0'>
          <button
            type='button'
            className={clsx('menu-link px-3 py-2', {active: menuMode === 'light'})}
            aria-pressed={menuMode === 'light'}
            onClick={() => switchMode('light')}
            data-kt-element='mode'
            data-kt-value='light'
          >
            <span className='menu-icon' data-kt-element='icon'>
              <KTSVG path='/media/icons/duotune/general/gen060.svg' className='svg-icon-3' />
            </span>
            <span className='menu-title'>Açık</span>
          </button>
        </div>
        {/* end::Menu item */}

        {/* begin::Menu item */}
        <div className='menu-item px-3 my-0'>
          <button
            type='button'
            className={clsx('menu-link px-3 py-2', {active: menuMode === 'dark'})}
            aria-pressed={menuMode === 'dark'}
            onClick={() => switchMode('dark')}
            data-kt-element='mode'
            data-kt-value='dark'
          >
            <span className='menu-icon' data-kt-element='icon'>
              <KTSVG path='/media/icons/duotune/general/gen061.svg' className='svg-icon-3' />
            </span>
            <span className='menu-title'>Koyu</span>
          </button>
        </div>
        {/* end::Menu item */}

        {/* begin::Menu item */}
        <div className='menu-item px-3 my-0'>
          <button
            type='button'
            className={clsx('menu-link px-3 py-2', {active: menuMode === 'system'})}
            aria-pressed={menuMode === 'system'}
            onClick={() => switchMode('system')}
            data-kt-element='mode'
            data-kt-value='system'
          >
            <span className='menu-icon' data-kt-element='icon'>
              <KTSVG path='/media/icons/duotune/general/gen062.svg' className='svg-icon-3' />
            </span>
            <span className='menu-title'>Sistem</span>
          </button>
        </div>
        {/* end::Menu item */}

        <div className='separator my-2'></div>

        <div className='menu-content px-3 text-muted text-uppercase fs-7'>İçerik genişliği</div>

        {/* begin::Layout width item */}
        <div className='menu-item px-3 my-0'>
          <button
            type='button'
            className={clsx('menu-link px-3 py-2', {active: layoutWidth === 'full'})}
            aria-pressed={layoutWidth === 'full'}
            onClick={() => switchLayoutWidth('full')}
          >
            <span className='menu-icon' data-kt-element='icon'>
              <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-3' />
            </span>
            <span className='menu-title'>Tam genişlik</span>
          </button>
        </div>
        {/* end::Layout width item */}

        {/* begin::Layout width item */}
        <div className='menu-item px-3 my-0'>
          <button
            type='button'
            className={clsx('menu-link px-3 py-2', {active: layoutWidth === 'fixed'})}
            aria-pressed={layoutWidth === 'fixed'}
            onClick={() => switchLayoutWidth('fixed')}
          >
            <span className='menu-icon' data-kt-element='icon'>
              <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon-3' />
            </span>
            <span className='menu-title'>Sabit genişlik</span>
          </button>
        </div>
        {/* end::Layout width item */}
      </div>
      {/* end::Menu */}
    </>
  )
}

export {ThemeModeSwitcher}
